<template>
  <section class="su-zero">
    <su-licenses-modal
      v-if="showLicensesModal"
      @close="showLicensesModal = false"
    />

    <div class="su-zero__banner">
      <h1>
        домашняя школа для&nbsp;5–11&nbsp;классов при&nbsp;университете «Синергия»
        с&nbsp;подходом, ориентированным на&nbsp;будущее ребенка
      </h1>

      <h3>школьный <br> университет</h3>

      <div class="su-zero__banner_cheaps">
        <span>гос. аттестат</span>
        <span>поддержка 24/7</span>
        <span>сильные преподаватели</span>
      </div>

      <button
        class="m-btn su-zero__banner_btn"
        @click="$emit('openModal')"
      >
        хотим поступить в школу
      </button>

      <img
        src="/v2/school-university/zero/image.webp"
        alt="школьницы"
        class="su-zero__banner_image"
        loading="lazy"
      >
    </div>

    <div class="su-zero__items">
      <div class="su-zero__item">
        <h4><span>топ 1</span> <br> edtech-компаний</h4>
        <p>*по&nbsp;версии Smart Ranking</p>
      </div>
      <div class="su-zero__item">
        <h4>с <span>1999</span> года Синергия обучает подростков и&nbsp;детей онлайн</h4>
      </div>
      <div class="su-zero__item">
        <h4>собственная образовательная платформа</h4>
      </div>
      <div class="su-zero__item">
        <h4>комьюнити единомышленников и&nbsp;друзей</h4>
      </div>
      <div class="su-zero__item">
        <h4>гос. лицензия и&nbsp;аккредитация</h4>
        <button
          class="m-btn"
          @click="showLicensesModal = true"
        >
          проверить лицензию
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import SuLicensesModal from './SuLicensesModal.vue';

export default {
  name: 'SuZero',
  components: { SuLicensesModal },
  data: () => ({
    showLicensesModal: false,
  }),
};
</script>

<style scoped lang="scss">
  .su-zero {
    display: flex;
    flex-direction: column;
    gap: calc(var(--scale) * 20);

    @include media-down($size-mobile) {
      gap: calc(var(--scale) * 16);
    }

    &__items {
      display: flex;
      gap: 1.25rem;
      height: 12rem;

      @include media-down($size-tablet) {
        display: grid;
        grid-template-columns: repeat(4, 17.8rem);
        grid-template-rows: repeat(2, 12.8rem);
        gap: 0.8rem;
        height: auto;
      }

      @include media-down($size-mobile) {
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 0.4rem));
        grid-template-rows: repeat(3, 12.8rem);
      }
    }
  }

  .su-zero__banner {
    height: calc(var(--scale) * 720);
    padding: 2rem 2.5rem;
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 60px;

    background-color: #FF5319;
    background-image: url("/v2/school-university/zero/bg.webp");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 512);
      padding: 1.2rem 1.6rem 0.8rem;
      border-radius: 3.2rem;
      background-image: url("/v2/school-university/zero/bg-tablet.webp");
    }

    @include media-down($size-mobile) {
      height: calc(var(--scale) * 720);
      background-image: url("/v2/school-university/zero/bg-mobile.webp");
    }

    h1 {
      max-width: calc(var(--scale) * 715);
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 334);
        font-size: 1.8rem;
      }
    }

    h3 {
      margin-top: auto;

      font-weight: 500;
      font-size: 11.25rem;
      line-height: 70%;
      letter-spacing: -0.08em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        font-size: 12rem;
        order: 3;
        margin-top: 0.8rem;
      }

      @include media-down($size-mobile) {
        margin-top: 1.6rem;
        font-size: 6.2rem;
      }
    }

    &_cheaps {
      margin-top: 2.5rem;
      display: flex;
      gap: 0.25rem;

      @include media-down($size-tablet) {
        margin-top: auto;
        order: 2;
      }

      @include media-down($size-mobile) {
        flex-wrap: wrap;
      }

      span {
        display: block;
        padding: calc(var(--scale) * 10) 1.25rem;

        background-color: #FFFFFF;
        border: 1px solid rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(5px);
        border-radius: 2.5rem;

        font-weight: 400;
        font-size: 1.25rem;
        line-height: 130%;
        color: #FA5019;

        @include media-down($size-tablet) {
          padding: 0.7rem 1.2rem;
          font-weight: 500;
          font-size: 1.4rem;
        }
      }
    }

    &_btn {
      position: absolute;
      z-index: 2;
      width: calc(var(--scale) * 506);
      height: calc(var(--scale) * 122);
      right: 2.5rem;
      bottom: 2.5rem;

      background-color: #5237E6;
      box-shadow: 10px 10px 50px rgba(#071539, 0.1), 4px 4px 20px rgba(#071539, 0.05);
      border-radius: 2.5rem;
      transition: 200ms;

      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        order: 4;
        position: static;
        width: calc(100% + 1.6rem);
        margin-left: calc(-1 * 0.8rem);
        margin-top: 3rem;
        height: 8rem;
        box-shadow: 1rem 1rem 5rem rgba(7, 21, 57, 0.1), 0.4rem 0.4rem 2rem rgba(7, 21, 57, 0.05);
        font-size: 1.8rem;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #846EFB;
        }
      }
    }

    &_image {
      position: absolute;
      right: 0;
      bottom: 0;

      width: calc(var(--scale) * 867);

      @include media-down($size-tablet) {
        display: none;
      }
    }
  }

  .su-zero__item {
    height: 100%;
    padding: 1.5rem calc(var(--scale) * 30);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex-basis: 100%;

    background-color: #F9F9F9;
    background-position: right bottom;
    background-repeat: no-repeat;
    border-radius: 2.5rem;

    @include media-down($size-tablet) {
      padding: 1.2rem 1.2rem 1.2rem 1.6rem;
      background-color: #FFFFFF;
    }

    &:nth-of-type(1) {
      background-image: url("/v2/school-university/zero/top.svg");

      @include media-down($size-tablet) {
        grid-column: 1 / 3;
        background-image: url("/v2/school-university/zero/top-tablet.svg");
      }

      @include media-down($size-mobile) {
        grid-column: 1 / 2;
      }
    }

    &:nth-of-type(2) {
      grid-column: 3 / 5;

      @include media-down($size-mobile) {
        grid-column: 2 / 3;
      }
    }

    &:nth-of-type(5) {
      background-image: url("/v2/school-university/zero/gerb.svg");

      @include media-down($size-tablet) {
        grid-column: 3 / 5;
        background-image: url("/v2/school-university/zero/gerb-tablet.svg");
      }

      @include media-down($size-mobile) {
        grid-column: 1 / 3;
      }
    }

    h4 {
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #02120F;

      @include media-down($size-tablet) {
        font-weight: 400;
        font-size: 1.6rem;
        line-height: 130%;
        letter-spacing: -0.02em;
      }

      span {
        color: #FF5319;
      }
    }

    p {
      font-size: 1.25rem;
      line-height: 130%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-weight: 500;
        font-size: 1.4rem;
      }
    }

    button {
      position: relative;
      font-weight: 400;
      font-size: 1.25rem;
      line-height: 100%;
      color: #5237E6;

      @include media-down($size-tablet) {
        font-weight: 500;
        font-size: 1.6rem;
      }

      &:after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #5237E6;;
        transition: width 0.2s linear;
      }

      &:hover:after {
        width: 0;
        right: 0;
        left: auto;
      }
    }
  }

@include media-down($size-mobile) {
  ::v-deep(.gos-licenses__slider) {
    max-width: calc(var(--scale) * 334);
    width: 100% !important;
  }
}
</style>
